export default __webpack_public_path__ + "static/media/bit-xnft-black.ededa2e8.svg";